import { toWhatsAppNumber } from "@/components/data";
import type { LinkedInRapido, WhatsAppRapido } from "@/types/freelancer-painel";

export function whatsAppWebUrl(numero: string): string {
  return `https://web.whatsapp.com/send?phone=${numero}`;
}

export interface CanaisWhatsApp {
  numero: string | null;
  jetsalesUrl: string | null;
}

/** Enquanto o resumo não chega, o número sai do telefone da própria lista. */
export function canaisWhatsApp(resumo: WhatsAppRapido | null | undefined, telefone?: string | null): CanaisWhatsApp {
  return {
    numero: resumo?.numero ?? (telefone ? toWhatsAppNumber(telefone) : null),
    jetsalesUrl: resumo?.jetsales_url ?? null,
  };
}

export function cargoAtualTexto(linkedin: LinkedInRapido): string | null {
  if (linkedin.cargo_atual && linkedin.empresa_atual) return `${linkedin.cargo_atual} na ${linkedin.empresa_atual}`;
  return linkedin.cargo_atual ?? linkedin.empresa_atual ?? null;
}

export function experienciaTexto(linkedin: LinkedInRapido): string | null {
  const partes = [
    linkedin.senioridade,
    linkedin.anos_experiencia != null ? `${linkedin.anos_experiencia} ${linkedin.anos_experiencia === 1 ? "ano" : "anos"} de experiência` : null,
  ].filter(Boolean);
  return partes.length ? partes.join(", ") : null;
}
